//
//
//
//
//
//
//

export default {
    name: "AlertError",
    data() {
        return{
            
        }
    },
    props: {
        error:{
            default: () => ({
                description: 'An error has occurred, please check your email and password',
                id: 'error'
            }),
            type: Object
        } 
    },
    computed: {
        showError() { return this.error?.code !== "DuplicateUserName" }
    },
}
